<div class="row">
  <div class="col-xs-12 col-md-4">
    <app-menudesktop></app-menudesktop>
  </div>
  <div class="col-xs-12 col-md-8 scyr-interior">
    <alertbox
      [messageBox]="messageCabecera"
      [typeException]="typeException"
      [messageComplet]="messageComplet"
    ></alertbox>
    <section>
      <h1>Datos del usuario</h1>
      <p>Estos son los datos que componen su perfil en nuestro sistema. Por favor, si alguno de ellos es incorrecto,
        le rogamos lo modifique para un correcto uso de los servicios interactivos.
      </p>
      <div class="col-xs-12 box">
        <form
          class=""
          id="form"
          method="get"
          action=""
        >
          <h2 class="line">Datos del usuario</h2>
          <fieldset>
            <legend class="sr-only">Formulario datos solicitante</legend>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'nombre'"
                  [setLabel]="'Nombre y Apellidos'"
                  [setValue]="nombre"
                  [setRequired]="true"
                  (outValue)="nombre = $event"
                ></sacyr-input>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-3">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'login'"
                  [setLabel]="'Usuario'"
                  [setValue]="login"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="login = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'email'"
                  [setLabel]="'Email'"
                  [setValue]="email"
                  [setRequired]="true"
                  [setError]="inputErrorEmail ? 'Introduzca un email válido' : ''"
                  (outValue)="email = $event"
                ></sacyr-input>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-3">
                <sacyr-input
                  [setType]="'tel'"
                  [setName]="'telefono1'"
                  [setLabel]="'Teléfono1'"
                  [setValue]="telefono1"
                  [setRequired]="true"
                  [setError]="inputErrorTelefono1 ? 'Introduzca un teléfono válido' : ''"
                  (outValue)="telefono1 = $event"
                ></sacyr-input>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-3">
                <sacyr-input
                  [setType]="'tel'"
                  [setName]="'telefono2'"
                  [setLabel]="'Teléfono2'"
                  [setValue]="telefono2"
                  [setRequired]="true"
                  [setError]="inputErrorTelefono2 ? 'Introduzca un teléfono válido' : ''"
                  (outValue)="telefono2 = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <br />
                <label for="consulta">
                  {{avisoEmail}}</label>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="input-form input-check">
                  <input
                    type="checkbox"
                    [(ngModel)]="efactura"
                    id="efacturacheck"
                    name="efacturacheck"
                  />
                  <label for="efacturacheck"> Suscripción a la factura electrónica </label>
                </div>
              </div>
            </div>
          </fieldset>
          <h2 class="line">Cambio contraseña</h2>
          <fieldset>
            <div class="row"></div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'password'"
                  [setName]="'oldPassword'"
                  [setLabel]="'Contraseña actual'"
                  [setValue]="oldPassword"
                  [setRequired]="true"
                  (outValue)="oldPassword = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'password'"
                  [setName]="'password'"
                  [setLabel]="'Contraseña nueva'"
                  [setValue]="password"
                  [setRequired]="true"
                  [compareWith]="passwordConfirm"
                  (outValue)="password = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'password'"
                  [setName]="'passwordConfirm'"
                  [setLabel]="'Confirmar contraseña'"
                  [setValue]="passwordConfirm"
                  [setRequired]="true"
                  [compareWith]="password"
                  (outValue)="passwordConfirm = $event"
                ></sacyr-input>
              </div>
            </div>

          </fieldset>
        </form>
      </div>
    </section>
    <div class="input-form input-button">
      <button
        (click)="actualizarUsuario()"
        type="submit"
        class="btn-default"
        value=""
      >Enviar</button>
    </div>
  </div>
</div>
